const messages = {
  'page.sign-in.title': 'Sign in',
  'page.sign-in.meta.title': 'Sign in',
  'page.sign-in.meta.description': 'Sign in to see ODIN administration goodness.',
  'page.sign-in.description': "Sign in to see ODIN administration goodness.'",
  'page.sign-in.form.email': 'Email address',
  'page.sign-in.form.password': 'Password',
  'page.sign-in.forgot-password': 'Forgot password',
  'page.sign-in.error': "Whoops, there's been a problem signing you in. Please try again.",
  'page.sign-in.staff-error.description': 'You are not allowed to access this resource',
}

export default messages
